import { render, staticRenderFns } from "./ListEvents.vue?vue&type=template&id=487278be&scoped=true"
import script from "./ListEvents.vue?vue&type=script&lang=js"
export * from "./ListEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487278be",
  null
  
)

export default component.exports